"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("@eres/api");
var dev = {
    tabuAPI: function () { return new api_1.BaseAPIConfig("https", "devmobile.dubailand.gov.ae", "Tabu.Mobile.Server", "api"); },
    tabuSmartAPI: function () { return new api_1.BaseAPIConfig("https", "devmobile.dubailand.gov.ae", "TabuSmartServicesApi"); },
};
var qa = {
    tabuAPI: function () { return new api_1.BaseAPIConfig("https", "stgapi.dubailand.gov.ae:8888", "DLD.Mobile", "api"); },
    tabuSmartAPI: function () { return new api_1.BaseAPIConfig("https", "stgapi.dubailand.gov.ae:8888", "TabuSmartServiceAPI"); },
};
var prod = {
    tabuAPI: function () { return new api_1.BaseAPIConfig("https", "mobile.dubailand.gov.ae", "TABU.Mobile.API", "api"); },
    tabuSmartAPI: function () { return new api_1.BaseAPIConfig("https", "mobile.dubailand.gov.ae", "TabuSmartServicesAPI"); },
};
var configs = {
    dev: dev,
    qa: qa,
    production: prod,
};
var cfg = (0, api_1.buildConfig)("qa", configs);
exports.default = cfg;
